// Add JavaScript to prefill form fields from URL parameters
function prefillFormFields() {
  const params = new URLSearchParams(window.location.search);

  // Prefill the location field
  const locationField = document.getElementById("location");
  const locationParam = params.get("location");
  if (locationField && locationParam) {
    locationField.value = locationParam;
  }

  // Prefill the reason field
  const reasonParam = params.get("reason");
  if (reasonParam) {
    const reasonInput = document.querySelector(`input[name='reason'][value='${reasonParam}']`);
    if (reasonInput) {
      reasonInput.checked = true;
    }
    if (reasonParam === "Other") {
      document.getElementById("reasonOther").classList.remove("hidden");
      const otherReason = params.get("otherReason");
      if (otherReason) {
        document.getElementById("reasonOther").value = otherReason;
      }
    }
  }

  // Prefill the name field
  const nameField = document.getElementById("name");
  const nameParam = params.get("name");
  if (nameField && nameParam) {
    nameField.value = nameParam;
  }

  // Prefill the phone field
  const phoneField = document.getElementById("phone");
  const phoneParam = params.get("phone");
  if (phoneField && phoneParam) {
    phoneField.value = phoneParam;
  }
}

// Call prefillFormFields on page load
window.addEventListener("load", prefillFormFields);

// Rest of the original script
const calendar = document.getElementById("calendar");
const timeSlotsSection = document.getElementById("timeSlotsSection");
const formSection = document.getElementById("formSection");
const timeSlotsContainer = document.getElementById("timeSlots");
const currentMonthDisplay = document.getElementById("currentMonth");
const reasonInputs = document.querySelectorAll("input[name='reason']");
const otherReasonInput = document.getElementById("otherReason");
const phoneField = document.getElementById("phone");
const successMessage = document.getElementById("successMessage");
const prevMonth = document.getElementById("prevMonth");
const nextMonth = document.getElementById("nextMonth");

// Hide the 'Other' text box initially
$(otherReasonInput).hide();

reasonInputs.forEach((reasonInput) => {
  $(reasonInput).on("change", () => {
    if (reasonInput.value === "Other" && reasonInput.checked) {
      $(otherReasonInput).show();
    } else {
      $(otherReasonInput).hide();
      otherReasonInput.value = ""; // Clear the input if hidden
    }
  });
});

$(phoneField).on("blur", () => {
  const phoneValue = phoneField.value.trim().replace(/[^0-9]/g, "");
  if (!/^1?\d{10}$/.test(phoneValue)) {
    alert("Invalid phone number. Please enter a valid 10-digit number (e.g., 8763773500).");
  }
});

function generateReferenceID() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let reference = "";
  for (let i = 0; i < 9; i++) {
    reference += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return reference;
}

function getSourceBasedOnLocation(location) {
  switch (location) {
    case "Kingston":
      return "Kingston";
    case "Montego Bay":
      return "Montego";
    case "Virtual":
      return "Zoom";
    default:
      return "web";
  }
}

let selectedTime = null;
let currentDate = new Date();
let selectedDate = null;
let selectedDateElement = null;
let selectedTimeSlotElement = null;

async function makeContact(payload) {
  const response = await fetch("https://wa.paperlessblueprint.com/api/wpbox/makeContact", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const errorText = await response.text();
    console.error("makeContact API error:", errorText);
    throw new Error("Failed to create contact.");
  }
  const responseData = await response.json();
  console.log("makeContact API response:", responseData);
  return responseData;
}

async function makeReservation(payload) {
  const response = await fetch("https://wa.paperlessblueprint.com/api/reminders/reservation/makeReservation", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const errorText = await response.text();
    console.error("makeReservation API error:", errorText);
    throw new Error(errorText);
  }
  const responseData = await response.json();
  console.log("makeReservation API response:", responseData);
  return responseData;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function makeReservationWithRetry(payload, retries = 3) {
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const result = await makeReservation(payload);
      return result;
    } catch (error) {
      if (attempt === retries - 1) throw error; // If out of retries, throw the error
      console.warn(`Retrying reservation (${attempt + 1})...`);
      await delay(1000); // Wait 1 second before retrying
    }
  }
}

$("#bookingForm").on("submit", async (e) => {
  e.preventDefault();

  if (!selectedDate || !selectedTime) {
    alert("Please select a date and time before submitting.");
    return;
  }

  const formData = new FormData(e.target);
  let phoneValue = formData.get("phone").trim().replace(/[^0-9]/g, "");
  if (phoneValue.length === 10) {
    phoneValue = "1" + phoneValue;
  }

  const location = formData.get("location");
  const source = getSourceBasedOnLocation(location);
  const generatedReference = generateReferenceID();

  const startTimeParts = selectedTime.split(":"),
    endTime = new Date(selectedDate);
  endTime.setHours(parseInt(startTimeParts[0]), parseInt(startTimeParts[1]) + 30, 0);

  const endTimeString = `${endTime.getHours().toString().padStart(2, "0")}:${endTime
    .getMinutes()
    .toString()
    .padStart(2, "0")}:00`,
    localTimeString = `${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${selectedDate
      .getDate()
      .toString()
      .padStart(2, "0")} ${selectedTime}`,
    localEndTimeString = `${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${selectedDate
      .getDate()
      .toString()
      .padStart(2, "0")} ${endTimeString}`;

  const makeReservationPayload = {
    token: "oJ3bWXOMePBoAr6S2MBiaT1d2t5RRFe8DC8sJ3V7b5e121be",
    phone: phoneValue,
    name: formData.get("name"),
    source: source,
    start_date: localTimeString,
    end_date: localEndTimeString,
    format: "Y-m-d H:i:s",
    external_id: generatedReference,
  };

  try {
    console.log("makeReservation Payload:", makeReservationPayload);

    // Make the reservation first
    const reservationResult = await makeReservationWithRetry(makeReservationPayload);
    console.log("Reservation Success:", reservationResult);

    // Success message immediately after reservation
    successMessage.textContent = `Reservation created successfully! Booking ID: ${generatedReference}, Date: ${selectedDate.toLocaleDateString()}, Time: ${selectedTime} - ${endTimeString}`;
    successMessage.classList.remove("hidden");

     // Now make the contact
const makeContactPayload = {
  token: "oJ3bWXOMePBoAr6S2MBiaT1d2t5RRFe8DC8sJ3V7b5e121be",
  phone: phoneValue,
  name: formData.get("name"),
  groups: `${location},${formData.get("reason")}`, // Add the selected reason to groups
  custom: {
    email: formData.get("email"),
    location: location,
    reason: formData.get("reason"), // Include the reason in custom fields as well
  },
};


    console.log("makeContact Payload:", makeContactPayload);
    await makeContact(makeContactPayload);
  } catch (error) {
    console.error("API Error:", error);
    successMessage.textContent = `An error occurred during contact creation: ${error.message}`;
    successMessage.classList.remove("hidden");
  }
});

function renderCalendar(date) {
  calendar.innerHTML = "";
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  weekdays.forEach((day) => calendar.insertAdjacentHTML("beforeend", `<div class="text-center font-bold">${day}</div>`));

  currentMonthDisplay.textContent = `${date.toLocaleString("default", { month: "long" })} ${date.getFullYear()}`;

  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

  for (let i = 0; i < firstDay; i++) {
    calendar.insertAdjacentHTML("beforeend", `<div></div>`);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const button = document.createElement("button");
    button.textContent = day;
    const buttonDate = new Date(date.getFullYear(), date.getMonth(), day);
    const isDayDisabled = isDateFullyPast(buttonDate);

    button.className = `p-2 border rounded ${
      isDayDisabled || buttonDate.getDay() === 6
        ? "disabled bg-gray-300"
        : "hover:bg-blue-500 hover:text-white"
    }`;

    if (!isDayDisabled && buttonDate.getDay() !== 6) {
      button.addEventListener("click", (e) => selectDate(e, buttonDate));
    }
    calendar.appendChild(button);
  }
}

function isDateFullyPast(date) {
  const now = new Date();
  const workingHours = {
    Monday: { start: 9.5, end: 17.5 },
    Tuesday: { start: 9.5, end: 17.5 },
    Wednesday: { start: 9.5, end: 17.5 },
    Thursday: { start: 9.5, end: 17.5 },
    Friday: { start: 9.5, end: 17.5 },
    Saturday: null,
    Sunday: { start: 13, end: 17 },
  };

  const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
  const workingHour = workingHours[dayName];

  if (!workingHour) {
    return true; // If there's no working hour for the day, mark as fully past
  }

  const lastSlotEnd = new Date(date);
  lastSlotEnd.setHours(Math.floor(workingHour.end), (workingHour.end % 1) * 60, 0, 0);

  return now > lastSlotEnd;
}

function selectDate(event, date) {
  if (selectedDateElement) {
    selectedDateElement.classList.remove("selected-date");
  }
  event.target.classList.add("selected-date");
  selectedDateElement = event.target;
  selectedDate = date;
  renderTimeSlots(date);
  timeSlotsSection.classList.remove("hidden");
}

function renderTimeSlots(date) {
  timeSlotsContainer.innerHTML = "";
  const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
  const workingHours = {
    Monday: { start: 9.5, end: 17.5 },
    Tuesday: { start: 9.5, end: 17.5 },
    Wednesday: { start: 9.5, end: 17.5 },
    Thursday: { start: 9.5, end: 17.5 },
    Friday: { start: 9.5, end: 17.5 },
    Saturday: null,
    Sunday: { start: 13, end: 17 },
  };
  const increment = 30;
  const workingHour = workingHours[dayName];

  if (!workingHour) {
    timeSlotsContainer.innerHTML = `<p class='text-gray-500'>No appointments available for ${dayName}.</p>`;
    return;
  }

  for (let hour = workingHour.start; hour < workingHour.end; hour += increment / 60) {
    const slotTime = `${Math.floor(hour).toString().padStart(2, "0")}:${((hour % 1) * 60).toString().padStart(2, "0")}:00`;
    const buttonTime = new Date(date);
    buttonTime.setHours(Math.floor(hour), (hour % 1) * 60, 0, 0);

    const button = document.createElement("button");
    button.textContent = `${Math.floor(hour)}:${((hour % 1) * 60).toString().padStart(2, "0")}`;
    button.className = `p-2 border rounded ${
      buttonTime <= new Date() ? "disabled bg-gray-300" : "hover:bg-blue-500 hover:text-white"
    }`;

    if (buttonTime > new Date()) {
      button.addEventListener("click", (e) => {
        selectTimeSlot(e, slotTime);
      });
    }

    timeSlotsContainer.appendChild(button);
  }
}

function selectTimeSlot(event, slotTime) {
  if (selectedTimeSlotElement) {
    selectedTimeSlotElement.classList.remove("selected-time");
  }
  event.target.classList.add("selected-time");
  selectedTimeSlotElement = event.target;
  selectedTime = slotTime;
  formSection.classList.remove("hidden");
}

prevMonth.addEventListener("click", () => {
  currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
  renderCalendar(currentDate);
});

nextMonth.addEventListener("click", () => {
  currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  renderCalendar(currentDate);
});

renderCalendar(currentDate);
